module.exports = __webpack_public_path__ + "fonts/87f962a.woff";